const apiUrl = {
    contacts: '/contacts',
}

export default apiUrl;